import React from "react";
import Avatar from "../../common/Avatar";

// =====================================================================
// CS3-B — Player attach card (Redesign 2.0 board `cs3`): "travels with a
// first message, removable before send." Reused by the N2-3a/3c message
// modal and the M3 mobile sheet.
//
// Variants (exact artboard recipes):
//  - "card"     CS3 reference: white, border #E5E7EB, r12, padding 12px 14px,
//               38px avatar, name 13px/600, meta 11.5px #6B7280,
//               remove disc 22px (#F3F4F6 → hover #FEE2E2/#DC2626).
//  - "attached" N2-3c in-modal: #F8FAFC fill, r10, padding 11px 13px,
//               36px avatar, name 12.5px/600, meta 11px.
//  - "sheet"    M3 mobile: #F8FAFC fill, r12, padding 11px 13px, 38px avatar,
//               meta 11px, remove disc 24px / 13px ×, no hover (mobile).
//
// The remove glyph is the verbatim U+00D7 ×, never an icon (brief Rule 2).
// =====================================================================

const VARIANT = {
  card: {
    box: "bg-white border border-[#E5E7EB] rounded-xl pl-3.5 pr-3.5 py-3",
    avatar: 38,
    name: "text-[13px]",
    meta: "text-[11.5px]",
    disc: "w-[22px] h-[22px] text-[12px] hover:bg-[#FEE2E2] hover:text-[#DC2626]",
  },
  attached: {
    box: "bg-[#F8FAFC] border border-[#E5E7EB] rounded-[10px] pl-[13px] pr-[13px] py-[11px]",
    avatar: 36,
    name: "text-[12.5px]",
    meta: "text-[11px]",
    disc: "w-[22px] h-[22px] text-[12px] hover:bg-[#FEE2E2] hover:text-[#DC2626]",
  },
  sheet: {
    box: "bg-[#F8FAFC] border border-[#E5E7EB] rounded-xl pl-[13px] pr-[13px] py-[11px]",
    avatar: 38,
    name: "text-[13px]",
    meta: "text-[11px]",
    disc: "w-6 h-6 text-[13px]",
  },
};

const PlayerAttachCard = ({
  name,
  meta,
  avatar = null,
  onRemove,
  removeLabel = "Remove player",
  variant = "card",
  className = "",
}) => {
  const v = VARIANT[variant] || VARIANT.card;
  return (
    <div className={`flex items-center gap-[11px] ${v.box} ${className}`}>
      <Avatar src={avatar} fallbackText={name} size={v.avatar} />
      <span className="flex flex-col gap-px flex-1 min-w-0">
        <span className={`${v.name} font-semibold text-[#111827] truncate`}>{name}</span>
        {meta && <span className={`${v.meta} text-[#6B7280] truncate`}>{meta}</span>}
      </span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={removeLabel}
          className={`flex-none rounded-full bg-[#F3F4F6] text-[#6B7280] leading-none inline-flex items-center justify-center ${v.disc}`}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default PlayerAttachCard;
